import React, { Component } from 'react';
import { linkList } from '../../services/apiRequests';
import appConfig from '../../config/client';
import Rank from '../../components/Table/rank';

class StatsPage extends Component {
  state = {
    post: [],
    showShortenUrl: false,
    shortenUrl: '',
    originalUrl: '',
    baseUrl: appConfig.baseUrl,
    clickSubmit: true,
    showError: false,
    apiError: '',
    showApiError: false,
    showLoading: false,
    exShortUrl: appConfig.baseUrl,
    customUrlCode: '',
  };

  async componentDidMount() {
    const { data: post } = await linkList('');
    this.setState({ post: post });
  }
  
  handleUserInput = (e) => {
    let {name, value} = e.target;

    if (name === 'customUrlCode') {
      value = value.replace(/[^a-zA-Z0-9_-]/g, '');
    }

    this.setState({
      [name]: value.trim(),
    })
  }
  
  async handleSubmit(e) {
    e.preventDefault();
    const { data: post } = await linkList(this.state.customUrlCode);
    this.setState({ post: post });
  }

  render() {
    return (
      <div className="landing">
        <div className="table-link-list">
          <div className="tablename">Top 100 visited URLs</div>
          <form className="link-shortener-form" onSubmit={this.handleSubmit.bind(this)}>
            <div>
              <h3 className="subtitle">Find your URL*</h3>
            </div>

            <div className="parameter-bottom">
              <div className="input-box-description">
                <label className="input-box-label">
                  l.unigine.com/
                </label>
              </div>

              <input
                className="input-box-input"
                name="customUrlCode"
                placeholder="Enter your custom name..."
                value={this.state.customUrlCode}
                onChange={this.handleUserInput}
              />

              <button
                className='btn search-btn waves-effect waves-light blue lighten-1'
                name="action"
                // onClick={this.handleSubmit}
              >
                Search
              </button>
            </div>
          </form>

          <Rank data={this.state.post} />
        </div>
      </div>
    );
  }
}

export default StatsPage;



// WEBPACK FOOTER //
// ./src/containers/pages/StatsPage.js